import axios from 'axios'
import config from '../config'

export default axios.create({
  baseURL: config.BASE_URL,
  timeout: 31000,
  headers: {
    Accept: 'application/json',
    auth_token: config.auth_token,
    locationorigin: window.location.origin,
    'content-type': 'application/json; charset=utf-8',
  },
})

export const middleofficeRequest = axios.create({
  baseURL: config.BASE_URL_V2,
  headers: {
    auth_token: config.auth_token,
    'Content-Type': 'application/json',
  },
})

export const backofficeRequest = axios.create({
  baseURL: config.BASE_URL_V2,
  headers: {
    auth_token: config.auth_token,
    'Content-Type': 'application/json',
  },
})
